import React from "react"
import PropTypes from "prop-types"
import { Button, Flex, Collapse } from "antd"
import { useTranslation } from "react-i18next"
import CustomDrawer from "ui/Drawer"
import FilterBadge from "components/FilterBadge"
import styles from "./TripFiltersDrawer.module.css"

// Mobile bottom-sheet variant of the trip filters. Reuses the same filter
// panel elements as the desktop dropdowns, laid out as accordion sections.
export default function TripFiltersDrawer({ open, setOpen, sections, onClear, hasFilters }) {
  const { t } = useTranslation()

  const items = sections.map((section) => ({
    key: section.key,
    label: (
      <span className={styles.sectionLabel}>
        <FilterBadge count={section.count} /> {section.label}
      </span>
    ),
    children: section.content
  }))

  const handleClear = () => {
    onClear()
    setOpen(false)
  }

  return (
    <CustomDrawer open={open} setOpen={setOpen} title={t("filterTags.filters", "Filters")}>
      <Collapse accordion bordered={false} items={items} className={styles.collapse} />
      <Flex gap={12} className={styles.footer}>
        <Button size="large" className="flex-1" type="primary" onClick={() => setOpen(false)}>
          {t("filterTags.apply", "Apply")}
        </Button>
        {hasFilters && (
          <Button size="large" className="flex-1" color="primary" variant="outlined" onClick={handleClear}>
            {t("filterTags.clear_all_filters")}
          </Button>
        )}
      </Flex>
    </CustomDrawer>
  )
}

TripFiltersDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
      content: PropTypes.node.isRequired
    })
  ).isRequired,
  onClear: PropTypes.func.isRequired,
  hasFilters: PropTypes.bool
}
